import './Banner.scss';

interface IBannerProps {
  description: string;
  title: string;
  hint: string;
  backgroundUrl?: string;
  onClick?: () => void;
}

const Banner = ({
  description,
  title,
  hint,
  backgroundUrl = '/images/default-banner.png',
  onClick,
}: IBannerProps) => {
  return (
    <div className="banner-wrapper" onClick={onClick}>
      <div className="banner-background-plain"></div>
      <img src={backgroundUrl} />
      <div className="banner-background-gradient"></div>
      <div className="banner-background-arrows">
        {[...Array(8)].map((_, i) => (
          <span key={i} className="banner-background-arrow" />
        ))}
      </div>

      <div className="banner-content">
        <div className="banner-content-description">{description}</div>
        <div className="banner-content-title">{title}</div>
        <div className="banner-content-hint">{hint}</div>
      </div>
    </div>
  );
};

export default Banner;
